import { FormTemplate } from "components/modal/templates";
import React from "react";
import { apply } from "sources/books/regionGroups";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateRegionGroupModal extends FormTemplate {
    sendRequest = (stateData) => {
        return apply(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;

        return <Markup {...config} renderField={this.renderField} renderSelect={this.renderSelect} />;
    };
}

const ConfiguredModal = (props) => <CreateRegionGroupModal {...props} config={config} initialState={initialState} />;

export default ConfiguredModal;
